import {
  DEFAULT_LIMIT,
  DEFAULT_OFFSET,
  EXPERIENCE_STATUS,
  SECTIONS,
  SORT_FIELD,
  SORT_ORIENTATION,
} from "@/constants/index.js";
import { DEFAULT_ROWS_PER_PAGE } from "@/constants/pagination";

export const initialState = {
  [SECTIONS.PROPERTIES]: {
    sortField: SORT_FIELD.PROPERTY_NAME,
    sortOrientation: SORT_ORIENTATION.ASC,
    filterFieldName: "",
    filterFieldValue: "",
    searchText: "",
    offset: DEFAULT_OFFSET,
    limit: DEFAULT_LIMIT,
  },
  [SECTIONS.MEDIA_LIBS]: {
    sortField: SORT_FIELD.PROPERTY_CREATED_AT,
    sortOrientation: SORT_ORIENTATION.ASC,
    searchText: "",
    offset: DEFAULT_OFFSET,
    limit: DEFAULT_LIMIT,
  },
  [SECTIONS.USERS]: {
    sortField: SORT_FIELD.USER_NAME,
    sortOrientation: SORT_ORIENTATION.ASC,
    searchText: "",
    offset: DEFAULT_OFFSET,
    limit: DEFAULT_LIMIT,
  },
  [SECTIONS.COACHES]: {
    sortField: SORT_FIELD.USER_NAME,
    sortOrientation: SORT_ORIENTATION.ASC,
    searchText: "",
    offset: DEFAULT_OFFSET,
    limit: DEFAULT_LIMIT,
  },
  [SECTIONS.MEMBERS]: {
    sortField: SORT_FIELD.MEMBER_ROLE,
    sortOrientation: SORT_ORIENTATION.ASC,
    searchText: "",
    offset: DEFAULT_OFFSET,
    limit: DEFAULT_LIMIT,
  },
  [SECTIONS.CONTACTS]: {
    sortField: SORT_FIELD.CONTACT_NAME,
    sortOrientation: SORT_ORIENTATION.ASC,
    searchText: "",
    offset: DEFAULT_OFFSET,
    limit: DEFAULT_LIMIT,
  },
  [SECTIONS.EXPERIENCES]: {
    sortField: SORT_FIELD.EXPERIENCE_CREATED_AT,
    sortOrientation: SORT_ORIENTATION.DESC,
    searchText: "",
    status: EXPERIENCE_STATUS.DRAFT,
    offset: DEFAULT_OFFSET,
    limit: DEFAULT_LIMIT,
  },
  [SECTIONS.MEDIA_ITEMS]: {
    offset: DEFAULT_OFFSET,
    limit: DEFAULT_LIMIT,
    sortField: SORT_FIELD.MEDIA_ITEM_CREATED_AT,
    sortOrientation: SORT_ORIENTATION.DESC,
    searchText: "",
    searchedTypes: [],
    searchedTags: [],
    searchedMembers: [],
  },
  [SECTIONS.ICONS]: {
    sortField: SORT_FIELD.ICON_NAME,
    sortOrientation: SORT_ORIENTATION.ASC,
    searchText: "",
    offset: DEFAULT_OFFSET,
    limit: DEFAULT_LIMIT,
  },
  [SECTIONS.UNIVERSITY]: {
    sortField: SORT_FIELD.UNIV_CATEGORY_ORDER,
    sortOrientation: SORT_ORIENTATION.ASC,
    searchText: "",
  },
  [SECTIONS.ASSETS]: {},
  [SECTIONS.ACCOUNTS]: {
    sortField: SORT_FIELD.ACCOUNTS,
    sortOrientation: SORT_ORIENTATION.ASC,
    filterFieldName: "",
    filterFieldValue: "",
    searchText: "",
    offset: DEFAULT_OFFSET,
    limit: DEFAULT_LIMIT,
  },
  [SECTIONS.ORGANIZATION_PROPERTIES]: {
    sortField: SORT_FIELD.PROPERTY_NAME,
    sortOrientation: SORT_ORIENTATION.ASC,
    filterFieldName: "",
    filterFieldValue: "",
    searchText: "",
    offset: DEFAULT_OFFSET,
    limit: DEFAULT_LIMIT,
  },
  [SECTIONS.ORGANIZATION_USERS]: {
    sortField: SORT_FIELD.USER_NAME,
    sortOrientation: SORT_ORIENTATION.ASC,
    searchText: "",
    offset: DEFAULT_OFFSET,
    limit: DEFAULT_ROWS_PER_PAGE,
  },
  [SECTIONS.ORGANIZATION_CONTACTS]: {
    sortField: SORT_FIELD.CONTACT_NAME,
    sortOrientation: SORT_ORIENTATION.ASC,
    filterFieldName: "",
    filterFieldValue: "",
    searchText: "",
    offset: DEFAULT_OFFSET,
    limit: DEFAULT_LIMIT,
  },
};
